export default __webpack_public_path__ + "static/media/SafeChats-MERGED.35819b65.png";